import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-unsupported-browser",
  imports: [CommonModule, TranslatePipe],
  templateUrl: "./unsupported-browser.html",
  styleUrl: "./unsupported-browser.scss"
})
export class UnsupportedBrowser {}
